import { render, staticRenderFns } from "./NavBarLink.vue?vue&type=template&id=246a8bd8&"
import script from "./NavBarLink.vue?vue&type=script&lang=js&"
export * from "./NavBarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports